export const light = {
  accent: {
    primary: '#6F36BB',
    secondary: '#4b247e',
  },
  text: '#301750',
  background: '#FFF',
  components: '#ede5f8',
};

export const dark = {
  accent: {
    primary: '#c699fc',
    secondary: '#dbbffd',
  },
  text: '#ede5f7',
  background: '#121212',
  components: '#271341',
};
